import React, { Component } from 'react';
import axios from 'axios';

class DisplayPokemon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pokeArray: [],
        }
    }
    //Function to list all the pokemon with their names, image and adopt button.
    renderPokeList() {
        const pokeList = this.state.pokeArray.map((pokemon, i) => {
            return (
                <div key={i} className="pokeTilesContainer" >
                    <div 
                        className="pokeTiles" 
                        value="Open"
                        onClick={() => 
                            this.props.selectedPokemonDetails(pokemon.name)}>
                        <p className="pokeName">{pokemon.name}</p>
                        <img className="pokeImage" src={`http://pokestadium.com/sprites/xy/${pokemon.name}.gif`} alt={pokemon.name}/>
                    </div>
                    <button 
                        className="adoptButton" 
                        onClick={() => this.props.adoptedPokemon(pokemon.name)}>Adopt
                    </button>
                </div>
            )
        });
        return (<div className="displayPokemonContainer wrapper">{pokeList}</div>);
    }
    //Function will display when API call return empty list
    renderEmptyState() {
        return (
            <div>
                <p>Loading pokemon list ...</p>
            </div>
        )
    }
    //Axios call to grab the list of pokemnn names
    async fetchPokemon() {
        try {
            const pokeData = await axios.get("https://pokeapi.co/api/v2/pokemon/", { 
                params: {
                offset: this.props.offset, 
                limit: this.props.limit,
                }
            })
        this.setState({
            pokeArray: pokeData.data.results        
        })   
        } catch (error) {
            alert("ERROR");
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.offset && this.props.offset !== prevProps.offset) {
            this.fetchPokemon();
        }
    }
    componentDidMount(){
        this.fetchPokemon();
    }

    render() {
        return(
            <div className="displayBackground">
                <h2 className="pokeTitle wrapper">Pokemon List</h2>
                <div>
                    {this.state.pokeArray.length ? this.renderPokeList() : this.renderEmptyState()}
                </div>
            </div>
        )  
    }
}
export default DisplayPokemon; 